import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllProducts, getAllTitleDesc, serverUrl } from "../api";
import Editor from "../components/Editor";
import Spinner from "../components/Spinner";
import { addProduct } from "../product";
import { StoreProvider } from "./ContextProvider";
import FileManagerModal from "./FileManager/FileManagerModal";

const AddTemplate = () => {
  const { setAllProduct, token } = useContext(StoreProvider);
  const navigate = useNavigate();

  const [allTags, setAllTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [shortDetail, setShortDetail] = useState("");
  const [description, setDescription] = useState("");
  const [templateInfo, setTemplateInfo] = useState({});
  const [selectedTags, setSelectedTags] = useState([]);
  const [response, setResponse] = useState({ isError: false, message: "" });
  const [price, setPrice] = useState({
    free: "100",
    starter: "0",
    business: "0",
    extended: "0",
  });
  const [zipFiles, setZipFiles] = useState({
    free: "",
    starter: "",
    business: "",
    extended: "",
  });
  const [licenseFiles, setLicenseFiles] = useState({
    free: "",
    starter: "",
    business: "",
    extended: "",
  });
  const [fileStatus, setFileStatus] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [planAccess, setPlanAccess] = useState({
    starter: true,
    business: true,
    team: true,
  });

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponse({ isError: false, message: "" });
    const templatesData = {
      ...templateInfo,
      is_featured:
        templateInfo?.is_featured?.toString() === "true" ? "true" : "false", // make sure it's a string
      short_detail: shortDetail,
      detail: description,
      price: JSON.stringify(price),
      tags: JSON.stringify(selectedTags),
      plan_access: JSON.stringify(planAccess),
    };
    if (zipFiles?.free || templatesData?.github_free_file_repo_url) {
      templatesData.price = JSON.stringify({
        ...price,
        free: "0",
      });
    }
    templatesData.download_file = JSON.stringify(zipFiles);
    templatesData.download_file_license = JSON.stringify(licenseFiles);

    const add = await addProduct(templatesData, token);
    setLoading(false);
    setResponse(add);
    if (!add?.isError) {
      const newProducts = await getAllProducts(token);
      setAllProduct(newProducts?.products);
      navigate(`/detail/${add?.product?.product_id}`);
    }
  };

  const handleFileManagerModal = (type, status) => {
    setIsModalOpen(true);
    setFileStatus({ type, status });
  };

  const handleSelectPreviewFile = (selectedFile) => {
    if (fileStatus?.type === "template") {
      const newFile = {
        ...zipFiles,
        [fileStatus.status]: selectedFile?.filename,
      };
      setZipFiles(newFile);
    } else if (fileStatus?.type === "license") {
      const newLicenseFile = {
        ...licenseFiles,
        [fileStatus.status]: selectedFile?.filename,
      };
      setLicenseFiles(newLicenseFile);
    } else if (fileStatus?.type === "featuredImage") {
      setTemplateInfo({ ...templateInfo, image: selectedFile?.filename });
    }
  };

  const loadAllTags = async () => {
    const tags = await getAllTitleDesc(token);
    if (!tags?.isError) {
      setAllTags(tags?.data);
    }
  };

  const handleSelectTag = (e) => {
    if (e.target.value) {
      const tag = JSON.parse(e.target.value);
      const tagIds = selectedTags?.map((item) => item?.id);
      if (tag?.id && !tagIds.includes(tag?.id)) {
        setSelectedTags([...selectedTags, tag]);
      }
    }
  };

  const removeTag = (slug) => {
    const existingTag = selectedTags.filter((item) => item?.slug !== slug);
    setSelectedTags(existingTag);
  };

  useEffect(() => {
    loadAllTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="mb-5">
      <div style={{ marginBottom: "150px" }}>
        <div className="px-4 xl:container mx-auto sm:px-4">
          <div className="-mx-4 sm:d-flex flex-wrap lg:flex-no-wrap">
            <div className="mb-5 w-full">
              <div className="mb-3 mt-3">
                <h2 className="mb-2 font-heading text-4xl font-bold tracking-tighter text-black">
                  Add Templates
                </h2>
                <p className="text-dark-text text-base">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer condimentum est felis.
                </p>
              </div>
              <form onSubmit={handleAdd}>
                <div className="d-flex justify-between">
                  <div className="w-50 pe-5">
                    <label htmlFor="name">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Name"
                      name="name"
                      id="name"
                      onInput={(e) =>
                        setTemplateInfo({
                          ...templateInfo,
                          name: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="w-50 pe-5">
                    <label htmlFor="slug">
                      Slug <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Slug"
                      name="slug"
                      id="slug"
                      onInput={(e) =>
                        setTemplateInfo({
                          ...templateInfo,
                          slug: e.target.value
                            ?.toString()
                            .trim()
                            .replace(/\s+/g, "-")
                            .toLowerCase(),
                        })
                      }
                      required
                    />
                  </div>
                </div>

                <div className="mt-5 d-flex justify-between">
                  <div className="w-50 pe-5">
                    <label htmlFor="built_with">Built with</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="example: Tailwind"
                      name="built_with"
                      id="built_with"
                      onInput={(e) =>
                        setTemplateInfo({
                          ...templateInfo,
                          built_with: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="w-50 pe-5">
                    <label htmlFor="version">Version</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="example: 1.1.1"
                      name="version"
                      id="version"
                      onInput={(e) =>
                        setTemplateInfo({
                          ...templateInfo,
                          current_version: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </div>

                <div className="mt-5 d-flex justify-between">
                  <div className="w-50 pe-5">
                    <label htmlFor="preview-link">Preview Link</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="example: https://example.com"
                      name="preview-link"
                      id="preview-link"
                      onInput={(e) =>
                        setTemplateInfo({
                          ...templateInfo,
                          preview_link: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="w-50 pe-5">
                    <label htmlFor="featured">Is Featured</label>
                    <select
                      id="featured"
                      className="form-control"
                      onChange={(e) =>
                        setTemplateInfo({
                          ...templateInfo,
                          is_featured: e.target.value,
                        })
                      }
                      name="is_featured"
                      required
                    >
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </div>
                </div>

                <div className="mt-5 d-flex justify-between">
                  <div className="w-50 pe-5">
                    <label htmlFor="default-variation">Default Variation</label>
                    <select
                      id="default-variation"
                      className="form-control"
                      onInput={(e) =>
                        setTemplateInfo({
                          ...templateInfo,
                          default_variation: e.target.value,
                        })
                      }
                      required
                    >
                      <option defaultValue={true} value="free">
                        Free
                      </option>
                      <option value="starter">Starter</option>
                      <option value="business">Business</option>
                      <option value="extended">Extended</option>
                    </select>
                  </div>
                  <div className="w-50 pe-5">
                    <label>Plan Access</label>
                    <div className="d-flex mt-2">
                      <div className="form-check me-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="plan-starter"
                          checked={planAccess.starter}
                          onChange={(e) =>
                            setPlanAccess({
                              ...planAccess,
                              starter: e.target.checked,
                            })
                          }
                        />
                        <label className="form-check-label" htmlFor="plan-starter">
                          Starter
                        </label>
                      </div>
                      <div className="form-check me-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="plan-business"
                          checked={planAccess.business}
                          onChange={(e) =>
                            setPlanAccess({
                              ...planAccess,
                              business: e.target.checked,
                            })
                          }
                        />
                        <label className="form-check-label" htmlFor="plan-business">
                          Business
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="plan-team"
                          checked={planAccess.team}
                          onChange={(e) =>
                            setPlanAccess({
                              ...planAccess,
                              team: e.target.checked,
                            })
                          }
                        />
                        <label className="form-check-label" htmlFor="plan-team">
                          Team
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5 d-flex justify-between">
                  <div className="w-50 pe-5">
                    <div>
                      <p>Featured Image: {templateInfo?.image}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal(
                            "featuredImage",
                            "featuredImage"
                          )
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                    <div className="mt-5">
                      {templateInfo?.image && (
                        <img
                          src={`${serverUrl}/image/${templateInfo?.image}`}
                          alt=""
                          style={{ width: 600 }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                {/* tags div*/}
                <div className="mt-3 d-flex justify-between">
                  <div className="w-50 pe-5">
                    <label htmlFor="default-variation">Select Tags</label>
                    <select
                      id="default-variation"
                      className="form-control"
                      onInput={handleSelectTag}
                      required
                    >
                      <option defaultValue={true} value="">
                        select
                      </option>
                      {allTags?.map((tag) => (
                        <option
                          key={tag?.id}
                          value={JSON.stringify({
                            id: tag?.id,
                            name: tag?.tag_name,
                            slug: tag?.slug || "",
                          })}
                        >
                          {tag?.tag_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="w-50 pe-5">
                    <h5>Tags</h5>
                    {selectedTags?.map((item) => (
                      <span
                        key={item?.id}
                        className="block rounded bg-primary text-light p-1 pe-0 me-2 mb-2"
                      >
                        {item?.name}
                        <span
                          onClick={() => removeTag(item?.slug)}
                          title="delete"
                          style={{ cursor: "pointer" }}
                          className="rounded-circle ms-2 bg-danger p-1"
                        >
                          x
                        </span>
                      </span>
                    ))}
                  </div>
                </div>

                <div className="w-50 mt-5 mb-5 pe-5">
                  <label htmlFor="github_repo_url">Github Repository URL</label>
                  <input
                    className="form-control mt-2"
                    type="text"
                    placeholder="Github Repository URL"
                    name="github_repo_url"
                    id="github_repo_url"
                    onInput={(e) =>
                      setTemplateInfo({
                        ...templateInfo,
                        github_repo_url: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="w-50 mt-5 mb-5 pe-5">
                  <label htmlFor="github_free_file_repo_url">
                    Github Free File Repository URL
                  </label>
                  <input
                    className="form-control mt-2"
                    type="text"
                    placeholder="Github Free File Repository URL"
                    name="github_free_file_repo_url"
                    id="github_free_file_repo_url"
                    onInput={(e) =>
                      setTemplateInfo({
                        ...templateInfo,
                        github_free_file_repo_url: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="w-50 mt-5 mb-5 pe-5">
                  <label htmlFor="doc_url">Documentation URL</label>
                  <input
                    className="form-control mt-2"
                    type="text"
                    placeholder="Documentation Url"
                    name="doc_url"
                    id="doc_url"
                    onInput={(e) =>
                      setTemplateInfo({
                        ...templateInfo,
                        doc_url: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="w-50 mt-5 mb-5 pe-5">
                  <label htmlFor="free_variation_text">
                    Free Variation Text
                  </label>
                  <input
                    className="form-control mt-2"
                    type="text"
                    placeholder="Free Variation Text"
                    name="free_variation_text"
                    id="free_variation_text"
                    onInput={(e) =>
                      setTemplateInfo({
                        ...templateInfo,
                        free_variation_text: e.target.value,
                      })
                    }
                  />
                </div>

                <h2 className="mt-5 text-base font-medium">Price</h2>
                <div className="mt-3 d-flex justify-between">
                  <div className="w-25 pe-5">
                    <label htmlFor="starter-price">Starter</label>
                    <input
                      className="mt-2 d-block w-full rounded border border-black bg-bg-color p-1 pl-3 pe-4 text-base text-body-color outline-none focus:border-primary"
                      type="number"
                      placeholder="example: 100"
                      name="starter-price"
                      id="starter-price"
                      onInput={(e) =>
                        setPrice({
                          ...price,
                          starter: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="w-25 pe-5">
                    <label htmlFor="business-price">Business</label>
                    <input
                      className="mt-2 d-block w-full rounded border border-black bg-bg-color p-1 pl-3 pe-4 text-base text-body-color outline-none focus:border-primary"
                      type="number"
                      placeholder="example: 200"
                      name="business-price"
                      id="business-price"
                      onInput={(e) =>
                        setPrice({
                          ...price,
                          business: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="w-25 pe-5">
                    <label htmlFor="extended-price">Extended</label>
                    <input
                      className="mt-2 d-block w-full rounded border border-black bg-bg-color p-1 pl-3 pe-4 text-base text-body-color outline-none focus:border-primary"
                      type="number"
                      placeholder="example: 500"
                      name="extended-price"
                      id="extended-price"
                      onInput={(e) =>
                        setPrice({
                          ...price,
                          extended: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <h2 className="mt-5 text-base font-medium">
                  Template File Area
                </h2>

                <div className="mt-5 d-flex justify-content-around">
                  {/* product zip filename */}
                  <div className="w-50 me-5">
                    <h5 className="mb-4 mt-5">Template zip file</h5>
                    <div className="mb-4 d-flex">
                      <p>Free version: {zipFiles?.free}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("template", "free")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                    <div className="mb-4 d-flex">
                      <p>Starter version: {zipFiles?.starter}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("template", "starter")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                    <div className="mb-4 d-flex">
                      <p>Business version: {zipFiles?.business}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("template", "business")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                    <div className="mb-4 d-flex">
                      <p>Extended version: {zipFiles?.extended}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("template", "extended")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                  </div>
                  {/* product txt filename */}
                  <div className="w-50 ms-5">
                    <h5 className="mb-4 mt-5">Template license file</h5>
                    <div className="mb-4 d-flex">
                      <p>Free version: {licenseFiles?.free}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("license", "free")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                    <div className="mb-4 d-flex">
                      <p>Starter version: {licenseFiles?.starter}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("license", "starter")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                    <div className="mb-4 d-flex">
                      <p>Business version: {licenseFiles?.business}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("license", "business")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                    <div className="mb-4 d-flex">
                      <p>Extended version: {licenseFiles?.extended}</p>
                      <button
                        type="button"
                        onClick={() =>
                          handleFileManagerModal("license", "extended")
                        }
                        className="btn btn-primary ms-auto"
                      >
                        Select
                      </button>
                    </div>
                  </div>
                </div>

                <Editor
                  description={description}
                  shortDetail={shortDetail}
                  setShortDetail={setShortDetail}
                  setDescription={setDescription}
                />

                <div className="mt-5 mb-5 text-center">
                  {response?.message && (
                    <p
                      style={{ color: response?.isError ? "red" : "green" }}
                      className="mb-4"
                    >
                      {response?.message}
                    </p>
                  )}
                </div>

                <div className="mt-5 d-flex items-center justify-center">
                  <button
                    type="submit"
                    disabled={loading ? true : false}
                    style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    className="d-flex items-center btn btn-primary ms-auto me-auto"
                  >
                    Add Template {loading && <Spinner />}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <FileManagerModal
        isSelect={true}
        openModal={isModalOpen}
        handleSelectPreviewFile={handleSelectPreviewFile}
        setOpenModal={setIsModalOpen}
      />
    </section>
  );
};

export default AddTemplate;
